import { ImageCropper } from "./ImageCropper";

export function CropImage({ closeModal, imgSrc, refresh, uploadImage }: { closeModal: () => void, imgSrc: string, refresh: () => Promise<void>, uploadImage: (file: File) => Promise<void> }) {
    const handleCompleteCrop = async () => {
        await refresh();
        closeModal();
    }
    return (
        <div
        className="relative z-10"
        aria-labelledby="crop-image-dialog"
        role="dialog"
        aria-modal="true"
        >
            <div className="fixed inset-0 bg-gray-300 bg-opacity-75 transition-all backdrop-blur-sm"></div>
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex justify-center px-2 py-12 text-center ">
                        <div className="relative rounded-2xl bg-white text-black text-left shadow-xl transition-all">
                            <div className="px-5 py-4">
                            <button
                                className="primary-button mb-4"
                                onClick={closeModal}
                            >
                                Close Menu
                            </button>
                            <ImageCropper
                                imgSrc={imgSrc}
                                handleClose={handleCompleteCrop}
                                uploadImage={uploadImage}
                                isCircular={false}
                            />
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    )
}